/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

const TWELVE_HOUR_LOCALES = [
	'en-us',
	'en-ca',
	'en-au',
	'en-nz',
	'en-ph',
	'en-in',
	'en-pk',
	'en-bd',
	'en-za',
	'es-mx',
	'es-co',
	'ar',
	'hi',
	'bn',
	'ur',
	'fil',
	'tl',
];

export function localeUses12Hour(locale: string): boolean {
	const lang = locale.toLowerCase();
	return TWELVE_HOUR_LOCALES.some((l) => lang.startsWith(l));
}
